module.exports = __webpack_public_path__ + "img/android10.d0bf1778.jpg";